import { gql } from "apollo-boost";

export default gql`
  query($query: String!) {
    search_rentals(should_track: false, query: $query) {
      total_count
    }

    search_sales(should_track: false, query: $query) {
      total_count
    }
  }
`;
